import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { CheckCircle2 } from 'lucide-react';

const FEEDBACK_FIELDS = [
  { key: 'effective_strategies', label: 'Most Effective Strategies', placeholder: 'e.g., visual schedules, modeling, breaks', color: 'focus:ring-emerald-300' },
  { key: 'recommendations_next', label: 'Recommendations for Next Session', placeholder: 'e.g., reduce noise, use more visuals', color: 'focus:ring-blue-300' },
  { key: 'thinking_moment', label: 'Most Prominent Thinking Moment', placeholder: 'e.g., noticed relationship between toy buoyancy and safety', color: 'focus:ring-violet-300' },
  { key: 'reasoning_strategy', label: 'Strategy to Strengthen Reasoning', placeholder: "e.g., ask more 'what if' questions", color: 'focus:ring-amber-300' },
  { key: 'parent_note', label: 'Parent Communication Note', placeholder: "e.g., child's triggers, stimming behavior", color: 'focus:ring-cyan-300' },
  { key: 'additional_observations', label: 'Additional Observations', placeholder: 'e.g., responded well to parent presence', color: 'focus:ring-slate-300' },
];

export function SessionFeedbackForm({ open, onOpenChange, feedback, setFeedback, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Nunito' }}>
            <CheckCircle2 className="w-5 h-5 text-green-500" /> End Session - Instructor Notes & Signature
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          {FEEDBACK_FIELDS.map(({ key, label, placeholder, color }) => (
            <div key={key}>
              <label className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1 block">{label}</label>
              <Textarea
                data-testid={`feedback-${key}`}
                className={`rounded-xl min-h-[60px] text-sm ${color}`}
                placeholder={placeholder}
                value={feedback[key]}
                onChange={e => setFeedback(prev => ({ ...prev, [key]: e.target.value }))}
              />
            </div>
          ))}

          <div className="grid grid-cols-2 gap-4 pt-2 border-t border-slate-200">
            <div>
              <label className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1 block">Instructor Name</label>
              <input
                data-testid="feedback-instructor-name"
                type="text"
                className="w-full px-3 py-2 border rounded-xl text-sm focus:ring-2 focus:ring-[#22D3EE] focus:border-transparent outline-none"
                value={feedback.instructor_name}
                onChange={e => setFeedback(prev => ({ ...prev, instructor_name: e.target.value }))}
              />
            </div>
            <div>
              <label className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1 block">Date</label>
              <input data-testid="feedback-date" type="text" className="w-full px-3 py-2 border rounded-xl text-sm bg-slate-50 outline-none" value={feedback.date} readOnly />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-2">
            <Button variant="outline" className="rounded-xl font-bold" onClick={() => onOpenChange(false)} data-testid="cancel-end-session">Cancel</Button>
            <Button className="rounded-xl bg-green-500 hover:bg-green-600 text-white font-bold gap-2" onClick={onSubmit} data-testid="confirm-end-session">
              <CheckCircle2 className="w-4 h-4" /> End & Save
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
